module.exports = __webpack_public_path__ + "img/20191026151616360截图20191026141953952.798cb755.jpg";